import { releaseStepTime, StepPlacement, settle } from "@repo/domain";
import type { PresentedOrderSetDto } from "@/lib/order-set-presentation";

/** Release a vacated source step, then grow the destination and settle later work. */
export function moveProcedureInOrderSet(
  set: PresentedOrderSetDto,
  orderId: string,
  stepId: string,
): PresentedOrderSetDto {
  const source = set.steps.findIndex((step) => step.orders.some((order) => order.orderId === orderId));
  const target = set.steps.findIndex((step) => step.stepId === stepId);
  const order = set.steps[source]?.orders.find((order) => order.orderId === orderId);
  if (!order || target < 0 || source === target || order.status === "completed" || order.status === "revoked")
    return set;
  const steps = set.steps.map((step, index) => ({
    ...step,
    orders:
      index === source
        ? step.orders.filter((item) => item.orderId !== orderId)
        : index === target
          ? [...step.orders, order]
          : step.orders,
  }));
  const vacated = steps[source]?.orders.every((item) => item.status === "revoked");
  const released = releaseStepTime(steps, new Set(vacated ? [source] : []), set.envelopeMinutes);
  const placed = released.steps
    .filter((step, index) => index !== source || step.orders.length > 0)
    .map((step) => ({
      ...step,
      placement: new StepPlacement({
        ...step.placement,
      }),
    }));
  const settled = settle(
    placed,
    placed.findIndex((step) => step.stepId === stepId),
  );
  const envelopeMinutes = Math.max(released.envelopeMinutes, ...settled.map((step) => step.placement.endMinutes));
  return {
    ...set,
    envelopeMinutes,
    authoredEnvelopeMinutes: envelopeMinutes,
    durationMinutes: envelopeMinutes,
    steps: settled.map(({ placement, ...step }) => ({
      ...step,
      placement: { offsetMinutes: placement.offsetMinutes, durationMinutes: placement.durationMinutes },
    })),
  };
}
